import { t } from '@lingui/core/macro';
import PopupNotification from './components/PopupNotification';

export function getLabel() {
  return {
    administration: t`Administration`,
    export: t`Export`,
    utilities: t`Utilities`,
    workflowSetup: t`Workflow Setup`,
    workflowConfiguration: t`Workflow Configuration`,
    adminWorkpages: t`Admin Workpages`,
    supportingTools: t`Supporting Tools`,
    active: t`Active`,
    addOption: t`Add Option`,
    organizationalUnits: t`Organizational Units`,
    organizationalUnitTypes: t`Organizational Unit Types`,
    orgUnitType: t`Organizational Unit Type`,
    orgPath: t`Organizational Hierarchy`,
    agencyRegister: t`Add Organizational Unit`,
    agencyTypeRegister: t`Add Organizational Unit Type`,
    akcRequiredIfVisible: t`Required`,
    documentTemplates: t`Document Templates`,
    documents: t`Documents`,
    bulkUploader: t`Bulk Upload`,
    archived: t`Archived`,
    city: t`City`,
    classNames: t`Styles`,
    code: t`Code`,
    jobs: t`Jobs`,
    faq: t`Help Center`,
    sequences: t`Sequences`,
    createForm: t`Create Form`,
    createList: t`Create List`,
    createObject: t`Create Object`,
    createSection: t`Create Section`,
    createWorkflow: t`Create Workflow`,
    disabledWorkflows: t`Disabled Workflows`,
    download: t`Download`,
    edit: t`Edit`,
    enum: t`Options`,
    format: t`Format`,
    forms: t`Forms`,
    formTags: t`Form Tags`,
    analytics: t`Analytics`,
    reports: t`Reports`,
    help: t`Help`,
    integrations: t`Integrations`,
    institutions: t`Institutions`,
    institution: t`Institution`,
    invoiceItems: t`Invoice Items`,
    isDefault: t`Is Default?`,
    label: t`Label`,
    lists: t`Lists`,
    lookup: t`Lookup`,
    mask: t`Mask`,
    maxLength: t`Max. Length`,
    minLength: t`Min. Length`,
    modifyComponent: t`Modify Component`,
    name: t`Name`,
    workflowNotifications: t`Workflow Notifications`,
    popupNotifications: t`Popup Notifications`,
    objectTypes: t`Entity Types`,
    organization: t`Organization`,
    position: t`Position`,
    postalCode: t`Postal Code`,
    role: t`Role`,
    roles: t`Roles`,
    reset: t`Reset`,
    save: t`Save`,
    section: t`Section`,
    sections: t`Sections`,
    selectComponent: t`Select a system component to manage`,
    sla: t`SLA`,
    state: t`State`,
    subsection: t`Subsection`,
    subsubsection: t`Subsubsection`,
    subtype: t`Sub Type`,
    themes: t`Themes`,
    themesAdd: t`Create New Theme`,
    themePreview: t`Theme Preview`,
    title: t`Title`,
    type: t`Type`,
    uiAddable: t`Addable`,
    uiAddableLabelButton: t`Add Button Label`,
    uiArrayType: t`Array Type`,
    uiCellClassName: t`Cell Class`,
    uiDefaultValue: t`Default Value`,
    uiExpandable: t`Expandable`,
    uiHideHeader: t`Hide Header`,
    uiHideTitle: t`Hide Title`,
    uiNewSection: t`New Section`,
    uiOrderable: t`Orderable`,
    uiPlaceHolder: t`Placeholder`,
    uiPositionButtons: t`Button Positions`,
    uiPrefix: t`Prefix`,
    uiReadonly: t`Readonly`,
    uiRemovable: t`Removable`,
    uiRemovableConfirm: t`Confirm on Remove?`,
    uiRemovableConfirmText: t`Confirm on Remove Text`,
    uiRemovableLabelButton: t`Remove Button Label`,
    uiSectionType: t`Section Type`,
    uiShowheaderOnEmpty: t`Show Header On Empty`,
    uiSimulateLabel: t`Simulate Label`,
    uiSufix: t`Suffix`,
    userRegister: t`Add User`,
    users: t`Users`,
    undo: t`Undo`,
    redo: t`Redo`,
    validate: t`Validate`,
    workpages: t`Workpages`,
    workflow: t`Workflow`,
    workTray: t`Work Tray`,
  };
}
